module.exports = __webpack_public_path__ + "static/media/stage-frontal.19b9a28e.jpg";